import { v4 as uuidv4 } from "uuid";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export const getNewDeviceUuid = () => {
    let cc_device_uuid = getCookie("cc_device_uuid");
    if (cc_device_uuid === '') {
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (10 * 60 * 1000));
        cc_device_uuid = uuidv4();
        document.cookie = `cc_device_uuid=${cc_device_uuid}; expires=${expiry.toGMTString()};path=/`
    }
    return cc_device_uuid;
}
const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift()
    } else {
        return "";
    }
}
export const gnerateDeviceUniqueId = async () => {
    let deviceUniqueId = localStorage.getItem('device_uid');
    if (!deviceUniqueId || deviceUniqueId === 'undefined') {
        const deviceVisitorId = (await (await FingerprintJS.load()).get()).visitorId;
        deviceUniqueId = deviceVisitorId;
        localStorage.setItem('device_uid', deviceUniqueId);
    }
    return deviceUniqueId;
}